import { TIMEZONE, getZonedParts, zonedTimeToUtc } from '@qaytim/shared';

/**
 * Efir vaqti — HAR DOIM Toshkent vaqti.
 *
 * `datetime-local` maydoni brauzerning mahalliy zonasida ishlaydi, ya'ni `new Date(value)` ni
 * o'qish uzoqdan ulangan yoki noto'g'ri sozlangan noutbukda efirni bir necha soat sljib
 * yuborardi — va xato faqat efir kuni ko'rinardi. Shuning uchun kiritilgan qiymat matn sifatida
 * ajratiladi va Toshkent zonasida talqin qilinadi.
 */
export function tashkentLocalInputToIso(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(value);
  if (!match) return '';

  const [, year, month, day, hour, minute] = match as unknown as [string, ...string[]];
  const parts = {
    year: Number(year),
    month: Number(month),
    day: Number(day),
    hour: Number(hour),
    minute: Number(minute),
  };

  // Shakl to'g'ri bo'lishi qiymat to'g'ri degani emas: `2026-13-45T99:99` naqshga mos keladi va
  // `zonedTimeToUtc` uni jimgina 2027-yilga o'tkazib yuboradi — server esa yaroqli ISO qiymatni
  // ko'radi va efirni butunlay boshqa kunga qo'yadi. Bunday qiymat forma xatosi bo'lishi kerak.
  if (
    parts.month < 1 ||
    parts.month > 12 ||
    parts.day < 1 ||
    parts.day > 31 ||
    parts.hour > 23 ||
    parts.minute > 59
  ) {
    return '';
  }

  return zonedTimeToUtc(parts).toISOString();
}

/** Toshkent vaqtida ko'rsatish: `2026-08-06 20:00`. */
export function formatTashkent(iso: string): string {
  const parts = getZonedParts(new Date(iso));
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${parts.year}-${pad(parts.month)}-${pad(parts.day)} ${pad(parts.hour)}:${pad(parts.minute)}`;
}

/** Faqat soat va daqiqa, Toshkent vaqtida — "18:42 dan keyin qayta urinib ko'ring" uchun. */
export function formatTashkentTime(iso: string): string {
  return formatTashkent(iso).slice('YYYY-MM-DD '.length);
}

/** `datetime-local` maydoni uchun boshlang'ich qiymat, Toshkent vaqtida. */
export function toTashkentLocalInput(iso: string): string {
  return formatTashkent(iso).replace(' ', 'T');
}

export { TIMEZONE };
